import { get } from 'lodash';

import {
  HEDWIG_TEMPLATE_EDITOR_PATH,
  HEDWIG_TEMPLATE_PORTAL_BASE_URLS,
} from 'omega-rtc/config';

const PRODUCTION_ENVIRONMENTS = new Set(['prd', 'prod', 'production']);

// Portal navigation is a UI concern; UCD only supplies the template ID and channel.
export const getHedwigTemplateUrl = (
  templateID?: string,
  channel?: string,
  environment: string = get(window, 'Grab.config.ENV', 'stg'),
): string | undefined => {
  if (typeof templateID !== 'string' || !templateID.trim() || typeof channel !== 'string') {
    return undefined;
  }

  let editorChannel: string;
  switch (channel.trim().toLowerCase()) {
    case 'push':
      editorChannel = 'push';
      break;
    case 'email':
      editorChannel = 'email';
      break;
    case 'pushinbox':
    case 'pci': // The persisted UCD channel for push + inbox.
      editorChannel = 'pushinbox';
      break;
    default:
      return undefined;
  }

  const normalizedEnvironment = typeof environment === 'string'
    ? environment.trim().toLowerCase() : '';
  const baseURL = PRODUCTION_ENVIRONMENTS.has(normalizedEnvironment)
    ? HEDWIG_TEMPLATE_PORTAL_BASE_URLS.prd
    : HEDWIG_TEMPLATE_PORTAL_BASE_URLS.stg;
  const url = new URL(HEDWIG_TEMPLATE_EDITOR_PATH(editorChannel), baseURL);
  url.searchParams.set('id', templateID.trim());
  return url.toString();
};
